import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { Audio } from '../../../components/molecues';
import source_nikkei from '../../../components/atoms/data/nikkei-book.svg';
import source_alc from '../../../components/atoms/data/alc-book.svg';
import source_alfa from '../../../components/atoms/data/alpha-book.svg';
import source_org from '../../../components/atoms/data/original-book.svg';
import { DIFFICULTY, ENGLISH_INDEX, SUBJECT_KBN } from '../../../common/constants.js';
import english_america from '../../../components/atoms/data/us-flag.svg';
import english_england from '../../../components/atoms/data/uk-flag.svg';
import english_australia from '../../../components/atoms/data/aus-flag.svg';

/*
props:
 onClickNext: callback function
*/

class Training1 extends Component {
    constructor(props) {
        super(props);

        this.refAudio = React.createRef();
        this.state = {
            play: false,
            loading: true,
            subject: this.props.subject,
        }
    }

    componentDidMount() {
        if(this.props.subject.audio) {
            this.props.dispatch({
                type: "DownloadAudio_Saga",
                subjectID: this.props.subject.id,
                name: this.props.subject.audio,
                mode: 0,
                onSuccess: this.onSuccessAudio,
                onFailure: this.onFailure,
            });
        } else {
            setTimeout(() => {
                this.loadingSubject = false;
                this.setState({loading: false});
                this.props.onLoadedFullText("");
            }, 100)
        }
        if(this.props.subject.pictureEn) {
            this.props.dispatch({
                type: "DownloadPictureEn_Saga",
                name: this.props.subject.pictureEn,
                subjectID: this.props.subject.id,
                onSuccess: this.onSuccessPictureEn,
                onFailure: this.onFailure,
            });
        }
    }

    onSuccessPictureEn = (pictureEn, id) => {
        let subject = this.state.subject;
        subject.pictureEnData = pictureEn;
        this.props.dispatch({
            type: "LoadSubject",
            subject: subject,
        });
    }

    creteDifficulty() {
        let difficulty = this.props.subject.difficulty;
        let level;
        if(difficulty === 1){
            level = DIFFICULTY[1];
        }else if(difficulty === 2){
            level = DIFFICULTY[2];
        }else if(difficulty === 3){
            level = DIFFICULTY[3];
        }else {
            level = '';
        }
        return level;
    }
    creteSource() {
        let source = this.props.subject.source;
        let sourceImg;
        if(source === 1){
            sourceImg = <img src={source_nikkei} alt="img" width="90px" height="24px" />;
        }else if(source === 2){
            sourceImg = <img src={source_alc} alt="img" width="90px" height="24px" />;
        }else if(source === 3){
            sourceImg = <img src={source_alfa} alt="img" width="90px" height="24px" />;
        }else if(source === 4){
            sourceImg = <img src={source_org} alt="img" width="90px" height="24px" />;
        }else{
            sourceImg = "";
        }
        return sourceImg;

    }
    createEnglish(english) {
        let englishImg;
        if(english === ENGLISH_INDEX.AMERICAN_ENGLISH){
            englishImg = <img src={english_america} alt="img" width="35px" height="24px" />;
        }else if(english === ENGLISH_INDEX.BRITISH_ENGLISH){
            englishImg = <img src={english_england} alt="img" width="35px" height="24px" />;
        }else if(english === ENGLISH_INDEX.AUSTRALIAN_ENGLISH){
            englishImg = <img src={english_australia} alt="img" width="35px" height="24px" />;
        }else{
            englishImg = "";
        }
        return englishImg;
    }
    onSuccessAudio = (audio, id) => {
        this.loadingSubject = false;
        let subject = this.state.subject;
        subject.audioData = audio;
        this.props.dispatch({
            type: "LoadSubject",
            subject: subject,
        });
        this.setState({loading: false});
        this.props.onLoadedFullText(audio);
    }
    onFailure = (status, error) => {
        this.setState({loading: false});
        this.props.onLoadedFullText();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isCurrent && !this.props.isCurrent) {
            this.refAudio.current.Stop();
        }
    }

    onClickPlay = (e) => {
        if (this.state.play) {
            this.setState({ play: false });
            this.refAudio.current.Stop();
        } else {
            this.setState({ play: true });
            this.refAudio.current.Play();
        }
    }
    onPlay = () => {
        this.setState({ play: true });
    }
    onStop = () => {
        this.setState({ play: false });
    }
    onEnded = () => {
        this.setState({ play: false });
    }
    createInfoText = () => {
        const subject = this.props.subject;
        return (
            <Info>
                <div>
                    by {subject.author}
                </div>
            </Info>
        )
    }
    render() {
        let size;
        let fontSize;
        const englishList = String(this.props.subject.english).split(",");
        const height = (window.innerHeight - 80 - 395) + "px";
        if (window.innerHeight >= 600) {
            size = "144px";
            fontSize = "48px";
        } else {
            size = "100px";
            fontSize = "32px";
        }

        const propsAudio = {
            src: [this.props.subject.audioData],
            play: 0,
            playbackRate: this.props.playbackRate,
            onPlay: this.onPlay,
            onStop: this.onStop,
            onEnded: this.onEnded,
            onChangePlaybackRate: this.props.onChangePlaybackRate,
            currentPage: 1
        }

        return (
            <Body Width={this.props.width} Height={this.props.height}>
                <Title>
                    <TitleInfo>
                        {this.props.subject.title}
                    </TitleInfo>
                    <LanguageInfo>
                        {
                            Number(this.props.subject.subjectKbn) !== Number(SUBJECT_KBN.LIMITED) && (
                                <>
                                    <Difficulty>
                                        {this.creteDifficulty()}
                                    </Difficulty>
                                    <Source>
                                        {this.creteSource()}
                                    </Source>
                                </>
                            )
                        }
                        {
                            englishList.map((english) => (
                                <English key={english}>
                                    {this.createEnglish(english)}
                                </English>
                            ))
                        }
                    </LanguageInfo>
                </Title>                
                {this.createInfoText()}
                <PlayerImageWrap Height={height}>
                    <PlayerImage play={this.state.play} size={size} fontSize={fontSize} onClick={this.onClickPlay}>
                        <i className="fas fa-volume-up" />
                    </PlayerImage>
                </PlayerImageWrap>
                <AudioWrap>
                    <Audio ref={this.refAudio} {...propsAudio} />
                </AudioWrap>
                <Loading Display={this.state.loading}>
                    <LoadingText>音声ファイル取得中</LoadingText>
                </Loading>
            </Body>
        );
    }
}

export { Training1 };

const Body = styled.div`
    width: ${props => (props.Width)};
    height: ${props => (props.Height)};
    position: relative;
`;
const Title = styled.div`
    height: 80px;

    padding: 10px;
    font-size: 18px;
    position: relative;
    z-index: 2;
`;
const TitleInfo = styled.div`
    font-weight: bold;
`;

const LanguageInfo = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
`;
const Difficulty = styled.div`
    margin: 2.5px 2px;
    width: 50px;
    height: 22px;

    text-align: center;
    color: #000;
    font-size: 16px;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #888;
`;
const Source = styled.div`
    margin: 4.5px 2px;
`;

const English = styled.div`
    margin: 4.5px 2px;
`;

const Info = styled.div`
    height: 32px;
    text-align: left;
    padding: 10px;
    display: flex;
    justify-content: flex-end;
`;
const PlayerImageWrap = styled.div`
    height: ${props => props.Height};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
`;
const PlayerImage = styled.div`
    width: ${props => props.size};
    height: ${props => props.size};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    box-shadow: 0 0 3px 1px  ${props => (props.play ? '#0077FF' : 'rgba(0, 0, 0, 0.2)')};
    margin: auto;
    color: ${props => (props.play ? '#0077FF' : '#cccccc')};
    transition-duration: 0.3s;
    i {
        font-size: ${props => props.fontSize};
    }
`;
const AudioWrap = styled.div`
    display: flex;
    justify-content: center;
`;

const Controls = styled.div`
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 80px;
    color: #fff;
    background-color: #6ECEB1;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Loading = styled.div`
    display: ${props => props.Display ? "" : "none"};
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.8);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    `;

const anime = keyframes`
    0% {border: 1px solid #ddd; color: #ddd;}
   50% {border: 1px solid #0077ff; color: #0077ff;}
  100% {border: 1px solid #ddd; color: #ddd;}
`;

const LoadingText = styled.div`
    border: 1px solid #ddd;
    color: #ddd;
    border-radius: 20px;
    background-color: #fff;
    padding: 5px 20px;
    text-align: center;
    position: absolute;
    top: 50px;
    left: 50%;
    max-width: 60%;
    transform: translateX(-50%);
    animation: ${anime} linear 2s;
    animation-iteration-count: infinite;
`;